<template>
    <div class="tree-view">
        <div class="toolbar">
            <filter-box @filter-changed="filterContent" />
            <button class="export-btn" @click="showExportPanel = true">
                [ export cv ]
            </button>
        </div>
        <export-panel
            v-if="showExportPanel"
            :content="content"
            @close="showExportPanel = false"
        />
        <tree-item
            v-for="(item, index) in filteredContent"
            :key="index"
            :item="item"
            :expandAll="filterText != ''"
            :filterText="filterText"
            :depth="0"
        />
    </div>
</template>

<script>
import axios from 'axios';
import TreeItem from './TreeItem.vue';
import FilterBox from './FilterBox.vue';
import ExportPanel from './ExportPanel.vue';

export default {
    name: 'TreeView',
    components: {
        TreeItem,
        FilterBox,
        ExportPanel,
    },
    data() {
        return {
            content: [],
            filterText: '',
            showExportPanel: false,
        };
    },
    computed: {
        filteredContent() {
            if (!this.filterText) {
                return this.content;
            }
            return this.filterItems(this.content);
        },
    },
    methods: {
        filterContent(filterText) {
            this.filterText = filterText.toLowerCase();
        },
        filterItems(items) {
            let res = [];
            for (let item of items) {
                if (
                    (item.text && item.text.toLowerCase().includes(this.filterText)) ||
                    (item.title && item.title.toLowerCase().includes(this.filterText))
                ) {
                    res.push(item);
                } else if (item.content) {
                    let children = this.filterItems(item.content);
                    if (children.length > 0) {
                        res.push({
                            ...item,
                            content: children,
                        });
                    }
                }
            }
            return res;
        },
    },
    mounted() {
        axios.get('content.json').then((response) => {
            this.content = response.data.content;
        });
    },
};
</script>

<style scoped>
.tree-view {
    font-family: monospace;
    color: green;
    text-align: left;
    padding-left: 10px;
}

.toolbar {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 4px;
}

.export-btn {
    background: none;
    border: none;
    color: green;
    font-family: monospace;
    font-size: 15px;
    cursor: pointer;
    padding: 0;
    white-space: nowrap;
}

.export-btn:hover {
    color: #4caf50;
}
</style>
